import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "./Auth.css";
import GuideWell_Blue from "../Assets/RSIDE.png";
import buildingImg from "../Assets/building_manager.jpg";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent. Check your inbox.");
    } catch (err) {
      setError("Email not found or invalid.");
    }
  };

  return (
    <div className="auth-container auth-bg-full">
      <img src={buildingImg} alt="" className="auth-full-bg-img" />
      <div className="auth-full-overlay" />

      <div className="auth-inner">
      {/* Left branding */}
      <div className="auth-brand-side">
        <h1 className="auth-brand-tagline">We'll get you<br />back in.</h1>
        <p className="auth-brand-sub">Happens to the best of us. Enter your email and we'll send you a reset link in seconds.</p>
        <ul className="auth-brand-features">
          <li><FaCheckCircle className="auth-feature-icon" /> Secure password reset link</li>
          <li><FaCheckCircle className="auth-feature-icon" /> Link expires in 1 hour</li>
          <li><FaCheckCircle className="auth-feature-icon" /> No account changes until confirmed</li>
        </ul>
      </div>

      <div className="auth-full-card-wrap">
        <div className="auth-card auth-dark-card">
          <img src={GuideWell_Blue} alt="RSIDE" className="auth-GuideWell_Blue" />

          <h2 className="auth-title">Reset Password</h2>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
              />
            </div>

            <button type="submit" className="auth-button">
              Send Reset Email
            </button>
          </form>

          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          <div className="auth-links">
            <Link to="/login" className="forgot-password">← Back to Login</Link>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
